import React from 'react';
import './Values.scss';

const Values = () => {
  const sectionStyle = {
    backgroundImage: 'url(/images/cards-bg.png)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  };

  return (
    <section className="values-section" id="onceliklerimiz" style={sectionStyle}>
      <div className="container">
        <div className="values-grid">
          {/* Sol taraf - Başlık ve açıklama */}
          <div className="values-intro" data-aos="fade-up" data-aos-duration="900">
            <h2>Önceliklerimiz</h2>
            <p>Sizlere en iyi finansal deneyimi sunmak için tüm süreçlerimizi önceliklerimiz etrafında şekillendiriyoruz</p>
          </div>
          
          {/* Sağ taraf - Değerler Kartları */}
          <div className="values-card" data-aos="fade-up" data-aos-duration="900">
            <div className="card-icon">
              <img src="icons/girisim.svg" alt="Girişimcilik" />
            </div>
            <h3>Güvenilirlik</h3>
            <p>Müşterilerimizin, iş ortaklarımızın ve çalışanlarımızın bize duyduğu güveni en değerli varlıklarımızdan biri olarak görüyoruz</p>
          </div>
          
          <div className="values-card" data-aos="fade-up" data-aos-duration="900">
            <div className="card-icon">
              <img src="icons/azim.svg" alt="Azim ve Cesaret" />
            </div>
            <h3>Yenilikçilik</h3>
            <p>Hayat Fintek olarak, yeniliği yalnızca bir hedef değil, bir kültür olarak benimsiyoruz. Tüm hizmetlerimizde bu bakış açısıyla hareket ediyor, kullanıcılarımıza daima geleceğin çözümlerini sunuyoruz.</p>
          </div>
          
          <div className="values-card" data-aos="fade-up" data-aos-duration="900">
            <div className="card-icon">
              <img src="icons/aidiyet.svg" alt="Aidiyet" />
            </div>
            <h3>Çeviklik</h3>
            <p>Çevik çalışma kültürünü benimseyerek, karar alma süreçlerimizi sadeleştirir, hızlı ve etkili çözümler üretiyoruz</p>
          </div>
          
          <div className="values-card" data-aos="fade-up" data-aos-duration="1000">
            <div className="card-icon">
              <img src="icons/fikir.svg" alt="Açık Fikirlilik" />
            </div>
            <h3>Kapsayıcılık</h3>
            <p>Kapsayıcılığı temel ilkemiz olarak görüyor, bireylerin ve kurumların ihtiyaçlarını anlayarak herkese yönelik kişiselleştirilmiş çözümler geliştiriyoruz.</p>
          </div>
          
          <div className="values-card" data-aos="fade-up" data-aos-duration="1100">
            <div className="card-icon">
              <img src="icons/saygi.svg" alt="İnsana ve Doğaya Saygı" />
            </div>
            <h3>Sürdürülebilirlik</h3>
            <p>Sürdürülebilirlik, yalnızca bir tercih değil; iş yapış şeklimizin temelini oluşturuyor. Tüm süreçlerimizde çevresel, ekonomik ve dijital sürdürülebilirlik ilkeleriyle hareket ediyoruz.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Values;
